import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {action, autorun, observable} from 'mobx';
import Toggle from '@material-ui/core/Switch';
import {withStyles} from '@material-ui/core/styles';
import {audio, secondary, typoLight, white} from '../themes/colors';
import {withHover} from '../compose/withHover';

let styles = {
    icon: {
        backgroundColor: white,
        height: 16,
        width: 16
    },
    checked: {
        '& + $bar': {
            opacity: '1 !important',
            backgroundColor: `${secondary}`
        }
    },
    checkedAudio: {
        '& + $bar': {
            opacity: '1 !important',
            backgroundColor: `${audio} !important`
        }
    },
    switchBase: {
        width: 48,
        height: 20,
        padding: 2,
        borderRadius: 10,
    },
    bar: {
        left: 'auto',
        right: 0,
        top: 0,
        height: 20,
        width: 34,
        backgroundColor: typoLight,
        borderRadius: 10,
        margin: 0,
        opacity: 1
    },
    root: {
        width: 48,
    }
};

const defaultToolTip = {position: {horizontal: 'right', vertical: 'bottom'}};

@withHover
@observer
class Switch extends Component {
    @observable isActive = this.props.isActive;

    componentDidMount() {
        this.listener = autorun(() => {
            this.updateIsActive(this.props.isActive);
        });
    }

    componentWillUnmount() {
        this.listener();
    }

    @action updateIsActive = (isActive) => {
        this.isActive = isActive;
    };


    render() {
        const {tooltip, classes, containerClass = '', containerStyle, onMouseOver, onMouseLeave, disabled, switchId, contentSlot, audioColor} = this.props;
        const switchTooltip = tooltip ? Object.assign({}, defaultToolTip, tooltip) : null;
        return (
            <div
                className={containerClass} style={containerStyle} onMouseOver={onMouseOver}
                onMouseLeave={onMouseLeave}>
                <Toggle
                    classes={{
                        root: classes.root,
                        switchBase: classes.switchBase,
                        bar: classes.bar,
                        icon: classes.icon,
                        checked: audioColor ?  classes.checkedAudio: classes.checked
                    }}
                    id={switchId} className="checkbox-indicator" disabled={disabled}
                    color={'secondary'}
                    disableRipple={true} checked={this.isActive} onChange={this.props.onClick}/>
                {switchTooltip && <div className="checkbox-label" style={{fontSize: '9px'}}>{switchTooltip.label}{contentSlot}</div>}
            </div>
        );
    }
}

Switch.propTypes = {
    isActive: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    tooltip: PropTypes.object,
    containerClass: PropTypes.string,
    containerStyle: PropTypes.object
};

export default withStyles(styles)(Switch);
